import { render, staticRenderFns } from "./ProofreadingWaiting.vue?vue&type=template&id=dea6a208&scoped=true"
import script from "./ProofreadingWaiting.vue?vue&type=script&lang=ts"
export * from "./ProofreadingWaiting.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingWaiting.vue?vue&type=style&index=0&id=dea6a208&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea6a208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dea6a208')) {
      api.createRecord('dea6a208', component.options)
    } else {
      api.reload('dea6a208', component.options)
    }
    module.hot.accept("./ProofreadingWaiting.vue?vue&type=template&id=dea6a208&scoped=true", function () {
      api.rerender('dea6a208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/ProofreadingWaiting.vue"
export default component.exports